import { Component, OnInit, Input, Output, EventEmitter, OnChanges, Renderer, ViewChild, ElementRef } from '@angular/core';
import { DealsWizardModel,DealServiceItemModel } from '../../../_models/_index';
import { DealStepEnum, DealStatusEnum } from '../../../_enums/_index';
import { GeneralService, UserService } from '../../../services/_index';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
    selector: 'deal-terms',
    moduleId: module.id,
    templateUrl: 'deal-terms.component.html'

})

export class DealTermsComponent implements OnInit {
    
    @ViewChild('termsApproved')
    approveCB: ElementRef;

    @Input()
    dealsWizard: DealsWizardModel;

    @Input()
    dealStep: DealStepEnum;

    @Output()
    private nextStepEvent: EventEmitter<DealStepEnum>;

    constructor(private userService: UserService,
        private generalService: GeneralService,
        private renderer: Renderer
    ) {
        this.nextStepEvent = new EventEmitter<DealStepEnum>();
    }

    ngOnInit() {
    }


    ngOnChanges() {

    }

    isCustomer() {
        return this.userService.isCustomer();
    }

    nextStep() {
        if (this.userService.isCustomer() && !this.dealsWizard.termsApproved) {
            this.generalService.showErrorDialog('חובה לאשר את תנאי השימוש');
            this.renderer.invokeElementMethod(this.approveCB, 'focus', []);
        }
        else {
            this.dealStep++;
            this.nextStepEvent.emit(this.dealStep);
        }
    }

    prevStep() {
        this.dealStep = this.dealsWizard.isTrial ? this.dealStep - 2 : this.dealStep - 1;
        this.nextStepEvent.emit(this.dealStep);
    }

    isReadOnly() {
        return this.dealsWizard.statusID >= DealStatusEnum.Signed || this.isCustomer();;
    }
    

}


// WEBPACK FOOTER //
// ./src/app/components/deal-wizard/deal-terms/deal-terms.component.ts